<template>

    <form action="" class="sky-form" method="post"
          @submit.prevent="validate">
        <fieldset class="no-padding">

            <section>
                <div class="row" style="margin-bottom: 6px">
                    <div class="col-sm-6">
                        <label class="label">Регион</label>
                        <label class="select">
                            <select name="region_id" v-model="formData.region_id" @change="updateCities">
                                <option value="">Выберите регион</option>
                                <option v-for="region in regions" :value="region.id"> {{ region.name }}</option>
                            </select>
                            <i></i>
                        </label>

                        <form-error for="formData.region_id"></form-error>

                    </div>
                    <div class="col-sm-6">
                        <label class="label">Город</label>
                        <label class="select">
                            <select name="city_id" v-model="formData.city_id">
                                <option value="">Выберите город</option>
                                <option v-for="city in cities" :value="city.id"> {{ city.name }}</option>
                            </select>
                            <i></i>
                        </label>

                        <form-error for="formData.city_id"></form-error>
                    </div>
                </div>

                <div class="row" style="margin-bottom: 6px">
                    <div class="col-sm-12">
                        <label class="label">Что необходимо:</label>
                        <label class="select">
                            <v-select label="name_rent_general"
                                      v-model="formData.machinery_type_id"
                                      placeholder="Введите запрос. (Примеры: Экскаватор, минипогрузчик, говновоз)"
                                      :filterable="false"
                                      :reduce="type => type.id"
                                      :options="types"
                                      :append-to-body="true"
                                      @search="onSearch">
                                <template slot="no-options">

                                    Ничего не найдено. Попробуйте сформулировать иначе

                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <img :src='"/images/machinery_icons/"+option.id + ".jpg"'
                                             style="width:60px; margin-right: 5px"/>
                                        <span>
                                    {{ rent ? option.name_rent_general : option.name_sale_general }} <br>
                                     <span style="color:blue">
                                         {{
                                             rent ? option.bref_note_rent : option.bref_note_sale
                                         }}
                                     </span>

                                </span>

                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ rent ? option.name_rent_general : option.name_sale_general }}
                                    </div>
                                </template>
                            </v-select>
                        </label>

                        <form-error for="formData.machinery_type_id"></form-error>
                    </div>
                </div>

                <div class="row" v-if="parameter_for_request && formData.machinery_type_id" style="margin-bottom: 6px">
                    <div class="col-sm-12">

                        <label class="label">{{ parameter_for_request.name }}</label>
                        <label class="select">
                            <select v-model="formData.machinery_parameter_value">
                                <option value="">Выберите значение</option>
                                <option v-for="option in parameter_for_request.extra_serialized" :value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <i></i>
                        </label>

                        <form-error for="formData.machinery_parameter_value"/>

                    </div>
                </div>



                <div class="row"  v-if=" ! auth_user">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="form-group">
                                <label class="label">Ваше имя <span class="text-danger">*</span></label>
                                <label class="input">
                                    <i class="icon-append fa fa-user"></i>
                                    <input type="text" name="contact_name" placeholder=""
                                           v-model="formData.contact_name">
                                    <b class="tooltip tooltip-bottom-right">Как мы можем к вам обращаться?</b>
                                </label>
                                <form-error for="formData.contact_name" />

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">

                            <label for="phone1" class="label">Телефон <span class="text-danger">*</span></label>
                            <label class="input">
                                <i class="icon-append fa fa-phone"></i>
                                <the-mask id="phone1"
                                          mask="+7 ###-###-####"
                                          type="tel" placeholder="Телефон"
                                          v-model="formData.contact_phone">

                                </the-mask>
                                <i></i>
                            </label>

                            <form-error for="formData.contact_phone" />

                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6" v-if="rent">
                        <div class="form-group">
                            <label class="label">Дата аренды <span class="text-danger">*</span></label>
                            <label class="select">
                                <select v-model="formData.request_date_type">
                                    <option value="A">В любое время</option>
                                    <option value="P">В период с... по...</option>
                                    <option value="C">Указать дату</option>
                                    <option value="B">Не позднее чем</option>
                                </select>
                                <i></i>
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">

                            <label class="label">Способ оплаты <span class="text-danger">*</span></label>
                            <label class="select">
                                <select v-model="formData.payment_method">
                                    <option value="1">Только наличный расчет</option>
                                    <option value="2">Только безналичный расчет</option>
                                    <option value="3">Наличный или безналичный</option>
                                </select>
                                <i></i>
                            </label>


                        </div>
                    </div>
                </div>

            </section>
            <hr>
            <section>
                <div class="row" v-if='formData.request_date_type != "A"'>
                    <section class="col-sm-6">
                        <div class="form-group">
                            <label class="label">Дата начала работ</label>
                            <label class="input">
                                <i class="icon-append fa fa-calendar"></i>
                                <date-picker v-model="formData.data1" valueType="format"></date-picker>
                                <b class="tooltip tooltip-bottom-right">Когда будут производиться работы?</b>
                            </label>

                    <!-- <form-error for="formData.data1" />-->


                        </div>
                    </section>
                    <section class="col-sm-6" v-if="formData.request_date_type == 'P'">
                        <div class="form-group">
                            <label class="label">Дата окончания работ</label>
                            <label class="input">
                                <i class="icon-append fa fa-calendar"></i>
                                <date-picker v-model="formData.data2" valueType="format"></date-picker>
                                <b class="tooltip tooltip-bottom-right">Когда работы будут закончены?</b>
                            </label>
                        </div>
                    </section>
                </div>
                <div class="row" v-if="rent">
                    <section class="col-sm-12">
                        <div class="form-group">
                            <label class="label">Место работ</label>
                            <label class="input">
                                <i class="icon-append fa fa-map-marker"></i>
                                <input type="text" v-model="formData.location" placeholder="">
                                <b class="tooltip tooltip-bottom-right">Где будут производиться работы?</b>
                            </label>
                        </div>
                    </section>
                </div>
                <div class="row">
                    <section class="col-sm-12">
                        <label class="textarea">
                            <!--                            mexzona-field-error-->
                            <textarea rows="3" v-model="formData.offer"
                                      :placeholder="rent ? 'Укажите объем работ и дополнительную информацию' :
                                                            'Укажите дополнительную информацию'"></textarea>
                        </label>
                    </section>
                </div>
            </section>
            <section>
                <div class="row">
                    <div class="col-md-6">

                        <vue-recaptcha ref="recaptcha"
                                       :sitekey="site_key"
                                       @verify="captcha"
                                       @expired="onCaptchaExpired"
                        />

                        <form-error for="captcha_token"/>


                    </div>
                </div>
            </section>
            <section>
                <div class="row">
                    <div class="col-md-8">

                    </div>
                    <div class="col-md-4">
                        <button class="btn btn-alt btn-icon btn-icon-right btn-icon-go pull-right" type="submit">
                            <span>Отправить заявку</span>
                        </button>
                    </div>
                </div>
            </section>
        </fieldset>
    </form>

</template>

<script>
export default {
    name: "PartsRequest"
}
</script>

<style scoped>

</style>
